var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.25,
    d: "M12.425 2.133a.476.476 0 00-.346.24L.541 22.357a.48.48 0 10.42.721h23.077a.48.48 0 00.421-.721L12.921 2.374a.48.48 0 00-.496-.24zm.075 1.443l10.697 18.54H1.803L12.5 3.575zm-.556 5.994c-.103 0-.165.062-.165.166v6.956c0 .103.062.18.165.18h1.112c.103 0 .165-.077.165-.18V9.736c0-.104-.062-.166-.165-.166h-1.112zm-.105 8.684c-.064.025-.09.088-.09.165v1.262c0 .104.062.166.165.166h1.172c.103 0 .165-.062.165-.166V18.42c0-.103-.062-.165-.165-.165h-1.172c-.026 0-.054-.007-.075 0z"
  })));
}

export default SvgCommonIconWarning;